export const MESSAGE_RECEIVED = 'received';
export const MESSAGE_SENT = 'sent';



// WEBPACK FOOTER //
// ./src/data/messageTypes.js